import { useEffect } from 'react';

import { useUiActions } from 'src/store';

export const useHideHubspotWidget = (hideHubspotWidget) => {
  const uiActions = useUiActions();

  useEffect(() => {
    if (!hideHubspotWidget) {
      return;
    }

    uiActions.hideHubspotWidget();

    return () => {
      uiActions.displayHubspotWidget();
    };
  }, [uiActions, hideHubspotWidget]);
};
